/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import TaskSearchForm from '../../../../../../components/Tasks/TaskSearchForm/index';

class RightSidebarMyTasks extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="page-sidebar-sticky">
          <div className="page-sidebar-sticky-wrp">
            <TaskSearchForm {...this.props} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default RightSidebarMyTasks;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/_myTasksCommon/RightSidebarMyTasks/RightSidebarMyTasks.js